import { render, staticRenderFns } from "./WorkDialog.vue?vue&type=template&id=bebe54ac"
import script from "./WorkDialog.vue?vue&type=script&lang=js"
export * from "./WorkDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkDialog.vue?vue&type=style&index=0&id=bebe54ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports